import {
  Button,
  ButtonBase,
  Grid,
  IconButton,
  Typography
} from '@material-ui/core'

import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import {
  BASE_COLORS,
  ERROR_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS
} from 'asterX-UI'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import { EditIcon } from 'asterX-UI/Icons/EditIcon'
import { ArrowRightIcon } from 'asterX-UI/Icons'
import { Modal } from 'asterX-UI/Modals'
import UserEdit from './UserEdit'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import PhoneView from 'components/PhoneView'
import { CS_MEET_CLIENT } from 'constants/events'
import useTaskApis from 'hooks/useTaskApis'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import useSeoApis from 'hooks/useSeoApis'
import { CarService, SalesService } from 'lib/api'
import { useSnackbar } from 'notistack'
import CreditApprovalModal from 'components/Desktop/CreditApprovalModal'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'

import CloseTaskComponent from 'components/Desktop/Tasks/CloseTaskComponent'
import CreateTaskComponent from 'components/Desktop/Tasks/CreateTaskComponent'
import CloseRLModal from 'components/Desktop/CloseRLModal'
import ClientNeedsModal from 'pages/Desktop/Selection/Manager/components/ClientNeedsModal'
import { PAYMENT } from 'constants/deals'
import { useAuthStore } from 'context/AuthStore'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import QRCode from 'react-qr-code'
import MaskedTextInput from 'asterX-UI/Inputs/MackedTextInput'
import { useResErrors } from 'hooks'
import BonusHistory from 'components/Desktop/Car/BonusHistory'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  },
  card: {
    borderRadius: 12,
    backgroundColor: BASE_COLORS.White,
    padding: '24px 16px',
    marginBottom: 12
  },
  name: {
    display: 'flex',
    gap: 6,
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginBottom: 12
  },
  edit: {
    color: PRIMARY_COLORS['700']
  },
  info: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12
  },
  phoneNumber: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    color: GRAY_COLORS['700']
  },
  credit: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 20
  },
  creditNotApplied: {
    backgroundColor: GRAY_COLORS['100'],
    borderRadius: 16,
    padding: '2px 8px',
    fontSize: 12,
    fontWeight: 500,
    color: GRAY_COLORS['700']
  },
  ticketChip: {
    backgroundColor: SUCCESS_COLORS['500'],
    borderRadius: 16,
    padding: '2px 8px',
    fontSize: 16,
    fontWeight: 500,
    color: GRAY_COLORS['100'],
    marginBottom: 12
  },
  bonusChip: {
    background:
      'linear-gradient(91.9deg, rgb(64, 224, 208)  4.4%, rgb(94, 124, 121) 89%)',
    borderRadius: 6,
    padding: '4px 10px',
    fontSize: 14,
    fontWeight: 600,
    color: GRAY_COLORS[50],
    marginBottom: 12,
    cursor: 'pointer'
  },
  creditApproved: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12,
    color: SUCCESS_COLORS['700']
  },
  btns: {
    display: 'flex',
    gap: 12,
    marginTop: 12
  },
  editNeeds: {
    borderRadius: 12,
    backgroundColor: BASE_COLORS.White,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: 16,
    fontWeight: 600,
    fontSize: 14
  }
}))

const CreditElement = ({ credit, index, classes, loadCreditRequest }) => (
  <div className={classes.credit} key={`creditIndex_${index}`}>
    <div>
      {credit?.creditorCode === 'JETCAR'
        ? 'Пред. одобрение:'
        : 'Онлайн кредит:'}
    </div>
    <CreditApprovalModal
      creditRequest={credit}
      loadCreditRequest={loadCreditRequest}
    />
  </div>
)

const ClientPage = ({ onClose }) => {
  const { getNotCompletedEventsBySaleId, completeEvent, taskIsLoading } =
    useTaskApis()
  const { hasActiveTicket, closeTicket, seoLoading, startTicket } = useSeoApis()
  const { standardCheck } = useResErrors()

  const {
    authStore: { user }
  } = useAuthStore()

  const {
    store: { sale, loading },
    funcs: { updateRseComments, pauseWl, missedWl }
  } = useSelectionStore()

  const { enqueueSnackbar } = useSnackbar()
  const classes = useStyles()
  const [uncompletedEvent, setUncompletedEvent] = useState(null)
  const [isPause, setIsPause] = useState(false)
  const [hasTicket, setHasTicket] = useState(false)
  const [ticket, setTicket] = useState('')
  const [creditRequest, setCreditRequest] = useState(null)
  const [loadCreditRequest, setLoadCreditRequest] = useState(false)
  const [creditPredodop, setCreditPredodop] = useState(null)
  const [load, setLoad] = useState(false)

  const [showQRModal, setShowQRModal] = useState(false)
  const [openPotrebCredit, setOpenPotrebCredit] = useState(false)
  const [clientPhoneNumber, setClientPhoneNumber] = useState(null)
  const [potrebCreditLink, setPotrebCreditLink] = useState('')

  const [car, setCar] = useState(null)
  const [openBonuses, setOpenBonuses] = useState(false)

  const [open, setOpen] = useState({
    isUserEditing: false,
    isClientNeeds: false,
    isCloseTaskOpen: false,
    isCloseRlModalOpen: false,
    isCreateTask: false,
    isCreditApproveOpen: false
  })

  useEffect(() => {
    initLoad()
  }, [])

  useEffect(() => {
    if (showQRModal) {
      getPotrebCreditLink()
    }
  }, [showQRModal])

  const initLoad = async () => {
    await getUncompletedEvents()
    await getHasTicket()
    await getCreditRequest()
    await getPredodopCreditRequest()
    await getCarByVin()
  }

  const handleOpen = type => () => {
    setOpen(prevState => ({
      ...prevState,
      [type]: !prevState?.[type]
    }))
  }

  const getCarByVin = async () => {
    await CarService.getCarByVin(sale?.selectedCarsForSale?.[0]?.vin).then(
      response =>
        standardCheck(response, () => {
          setCar(response.data)
        })
    )
  }

  const onSaveRse = async () => {
    await updateRseComments()
    handleOpen('isClientNeeds')()
  }
  const getUncompletedEvents = async () => {
    await getNotCompletedEventsBySaleId({
      saleId: sale?.id,
      type: CS_MEET_CLIENT,
      onSuccess: res => {
        setUncompletedEvent(res.data?.listEvents?.[0])
      }
    })
  }

  const getHasTicket = async () => {
    await hasActiveTicket({
      onSuccess: async res => {
        if (res?.code === 5) {
          return await startTicket({
            onSuccess: () => {
              setHasTicket(!!res?.ticketId)
              setTicket(res?.ticketNumber)
            }
          })
        }
        setHasTicket(!!res?.ticketId)
        setTicket(res?.ticketNumber)
      }
    })
  }

  const getCreditRequest = async () => {
    setLoadCreditRequest(true)
    await SalesService.getCreditRequestsByPhone(sale?.client?.phoneNumber).then(
      res => setCreditRequest(res?.data)
    )
    setLoadCreditRequest(false)
  }

  const getPredodopCreditRequest = async () => {
    setLoad(true)
    await SalesService.getPredodopByPhone(sale?.client?.phoneNumber).then(res =>
      setCreditPredodop(res?.data)
    )
    setLoad(false)
  }

  const getPotrebCreditLink = () => {
    SalesService.getPotrebCreditLink(user?.data?.branch?.code).then(res => {
      if (res?.data) {
        setPotrebCreditLink(res.data)
      }
    })
  }

  const sendWabaPotrebCredit = async () => {
    if (!sale?.id || !clientPhoneNumber) {
      enqueueSnackbar('Нет данных!', { variant: 'warning' })
      return
    }

    const res = await SalesService.sendWabaPotrebCredit(
      sale?.id,
      clientPhoneNumber.toNum()
    )

    if (res?.data) {
      enqueueSnackbar('Успешно отправлено!', { variant: 'success' })
    } else {
      enqueueSnackbar('Ошибка', { variant: 'error' })
    }
  }

  const handleChangePhone = e => {
    const value = e.target.value
    setClientPhoneNumber(value)
  }

  const onPauseWl = () => {
    getHasTicket()
    setIsPause(true)
    if (uncompletedEvent) {
      return handleOpen('isCloseTaskOpen')()
    }
    handleOpen('isCreateTask')()
  }

  const onMissedWl = () => {
    getHasTicket()
    getUncompletedEvents()
    handleOpen('isCloseRlModalOpen')()
  }

  const handleClose = () => {
    setIsPause(false)
    onClose()
  }

  const onSaveNewTask = async () => {
    if (hasTicket) {
      return await closeTicket({
        onSuccess: res => {
          if (isPause) {
            pauseWl()
          }
        }
      })
    }
    if (isPause) {
      pauseWl()
    }
    handleOpen('isCreateTask')()
  }

  const onSaveCloseTask = async isNew => {
    if (isNew) {
      await getUncompletedEvents()
      handleOpen('isCloseTaskOpen')()
      return handleOpen('isCreateTask')()
    }
    onCloseTask(handleOpen('isCloseTaskOpen'))()
  }

  const onCloseTask =
    (cb = () => {}) =>
    () => {
      cb()
      getUncompletedEvents()
      setIsPause(false)
    }

  const onReasonClose = async result => {
    if (uncompletedEvent) {
      return await completeEvent({
        data: {
          id: uncompletedEvent.id,
          result
        },
        onSuccess: async res => {
          if (hasTicket) {
            return await closeTicket({
              onSuccess: res => {
                missedWl(result)
              }
            })
          }
          return missedWl(result)
        }
      })
    }
    if (hasTicket) {
      return await closeTicket({
        onSuccess: res => {
          missedWl(result)
        }
      })
    }
    return missedWl(result)
  }

  const isEvraz =
    !!creditRequest?.length &&
    creditRequest.some(credit => credit?.creditorCode === 'EVRAZ')

  return (
    <PageContainerDesktop
      style={{
        height: '90vh'
      }}
      customHeader={
        <div className={classes.header}>
          <IconButton
            style={{
              color: GRAY_COLORS[400]
            }}
            onClick={handleClose}
            size={'medium'}
          >
            <ChevronLeftIcon />
          </IconButton>
          <div className={classes.heading}>Карточка клиента</div>
        </div>
      }
    >
      <LoaderBackdrop loading={taskIsLoading || seoLoading || loading} />

      <div className={classes.card}>
        <div className={classes.info}>
          <div className={classes.name}>
            <div>{sale?.client?.firstName}</div>
            <IconButton
              style={{
                color: GRAY_COLORS[500]
              }}
              onClick={handleOpen('isUserEditing')}
              size={'small'}
            >
              <EditIcon className={classes.edit} />
            </IconButton>
          </div>

          <div
            className={classes.bonusChip}
            onClick={() => setOpenBonuses(true)}
          >
            Бонусы
          </div>

          {!!ticket && <div className={classes.ticketChip}>{ticket}</div>}
        </div>

        <div className={classes.info}>
          <div className={classes.phoneNumber}>
            <PhoneView phone={sale?.client?.phoneNumber} />
          </div>
          <div className={classes.rl}>{`№ РЛ ${sale?.globalId}`}</div>
        </div>
        {!!creditRequest?.length &&
          creditRequest.map((credit, index) => (
            <CreditElement
              key={`creditElement_${index}`}
              credit={credit}
              index={index}
              classes={classes}
              loadCreditRequest={loadCreditRequest}
            />
          ))}
        <div className={classes.credit}>
          <div>Пред. одобрение: </div>
          <div>
            <CreditApprovalModal
              creditRequest={creditPredodop}
              loadCreditRequest={load}
            />
          </div>
        </div>
        {!isEvraz && (
          <div className={classes.credit}>
            <div>Онлайн кредит:</div>
            <div>
              <CreditApprovalModal />
            </div>
          </div>
        )}
        <div style={{ marginBottom: '12px' }}>
          <Button
            variant="contained"
            color={'primary'}
            fullWidth
            onClick={() => setOpenPotrebCredit(true)}
          >
            Отправить потреб.
          </Button>
        </div>
        <Button
          variant="contained"
          color={'primary'}
          fullWidth
          onClick={onPauseWl}
        >
          Приостановить подбор
        </Button>
        <div className={classes.btns}>
          <Button
            variant="contained"
            color={'secondary'}
            fullWidth
            onClick={onMissedWl}
          >
            В упущен
          </Button>
          {/*<Button
            variant="contained"
            fullWidth
            onClick={handleOpen('isRedirectModalOpen')}
          >
            Перенаправить
          </Button>*/}
        </div>
      </div>
      <ButtonBase
        className={classes.editNeeds}
        onClick={handleOpen('isClientNeeds')}
      >
        Потребности клиента
        <ArrowRightIcon style={{ color: PRIMARY_COLORS['700'] }} />
      </ButtonBase>
      <Modal open={open.isUserEditing} fullWidth maxWidth={'md'}>
        <UserEdit onClose={handleOpen('isUserEditing')} />
      </Modal>
      <Modal open={open.isClientNeeds} fullWidth maxWidth={'md'}>
        <ClientNeedsModal
          handleClose={handleOpen('isClientNeeds')}
          isEdit
          onSave={onSaveRse}
        />
      </Modal>

      <Modal open={open.isCloseTaskOpen} fullWidth>
        <CloseTaskComponent
          onClose={onCloseTask(handleOpen('isCloseTaskOpen'))}
          taskType={CS_MEET_CLIENT}
          onSave={onSaveCloseTask}
          taskId={uncompletedEvent?.id}
        />
      </Modal>
      <Modal open={open.isCreateTask} fullWidth>
        <CreateTaskComponent
          saleId={sale?.id}
          isPayment={sale?.saleStatus?.code === PAYMENT}
          globalId={sale?.globalId}
          client={{
            contactFullname: `${sale?.client?.firstName || ''} ${
              sale?.client?.lastName || ''
            }`,
            phoneNumber: sale?.client?.phoneNumber || '',
            additionalPhoneNumber: sale?.client?.additionalPhoneNumber || ''
          }}
          onClose={onCloseTask(handleOpen('isCreateTask'))}
          onSuccess={onSaveNewTask}
        />
      </Modal>
      <Modal
        open={open.isCloseRlModalOpen}
        onClose={handleOpen('isCloseRlModalOpen')}
        fullWidth
      >
        <CloseRLModal
          onClose={handleOpen('isCloseRlModalOpen')}
          onSave={onReasonClose}
        />
      </Modal>
      {/*<Modal
        open={open.isRedirectModalOpen}
        onClose={handleOpen('isRedirectModalOpen')}
        fullWidth
      >
        <RedirectClient onClose={handleOpen('isRedirectModalOpen')} />
      </Modal>*/}

      <ActionModal
        open={openPotrebCredit}
        onCancel={() => setOpenPotrebCredit(false)}
        title={'Отправить потреб.'}
        labelConfirm={'Отправить'}
        onClose={() => setOpenPotrebCredit(false)}
        labelCancel={'Отмена'}
        onConfirm={sendWabaPotrebCredit}
      >
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: 14, fontWeight: 500, color: GRAY_COLORS[400] }}
          >
            Cсылкa по потребительскому кредитованию будет отправлена на вацап
            клиента.
          </Typography>
        </Grid>
        <Grid item container display="flex" xs={12}>
          <Grid item>
            <Typography
              style={{ fontSize: 14, fontWeight: 500, color: GRAY_COLORS[400] }}
            >
              Если у клиента отсутствует Whats'app Вы можете показать QR код для
              перехода на страницу партнера
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 500,
                color: PRIMARY_COLORS[600],
                cursor: 'pointer',
                marginBottom: 5
              }}
              onClick={() => setShowQRModal(prevState => !prevState)}
            >
              {showQRModal ? 'Закрыть QR' : 'Показать QR'}
            </Typography>
          </Grid>
          {showQRModal && (
            <Grid
              item
              container
              display="flex"
              alignItems="center"
              justifyContent="center"
              xs={12}
              style={{
                marginBottom: 8
              }}
            >
              {potrebCreditLink && potrebCreditLink?.length > 0 ? (
                <Grid
                  item
                  style={{
                    border: `1px solid ${GRAY_COLORS[300]}`,
                    padding: 5,
                    borderRadius: 8
                  }}
                >
                  <QRCode
                    size={200}
                    style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                    value={`https://e-loan.homecredit.kz/${potrebCreditLink}`}
                  />
                </Grid>
              ) : (
                <Grid
                  item
                  container
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  xs={12}
                >
                  <Typography
                    style={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: ERROR_COLORS[600],
                      marginBottom: 10,
                      marginTop: 10
                    }}
                  >
                    Загрузка QR кода
                  </Typography>
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
        <Grid item xs={12}>
          <MaskedTextInput
            label={'Номер телефона'}
            mask={'8 (999) 999-99-99'}
            placeholder={'8'}
            fullWidth
            value={clientPhoneNumber}
            onChange={handleChangePhone}
          />
        </Grid>
      </ActionModal>

      <BonusHistory open={openBonuses} onClose={() => setOpenBonuses(false)} />
    </PageContainerDesktop>
  )
}

export default ClientPage
